import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
} from '@mui/material';
import { AppDispatch, RootState } from '../../configureStore';
import { FormExtractions } from '../../interface/returns';
import { RESTORE_EXTRACTED_JSON } from '../../redux/reducer/returns';

interface DraftFoundDialogProps {
    open: boolean;
    onClose: () => void;
}

const DraftFoundDialog = ({
    open,
    onClose,
}: DraftFoundDialogProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const draftExtractedJson = useSelector<RootState, FormExtractions | undefined>(
        ({ returns }) => returns.draftExtractedJson,
    );

    const handleContinueFromDraft = () => {
        if (draftExtractedJson) {
            dispatch({ type: RESTORE_EXTRACTED_JSON, extractedJson: draftExtractedJson });
        }
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>Draft Found</DialogTitle>
            <DialogContent>
                <Typography variant="body1">
                    A saved draft was found for this task. Would you like to continue where you left off?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Start Fresh</Button>
                <Button
                    onClick={handleContinueFromDraft}
                    variant="contained"
                    color="primary"
                >
                    Continue from Draft
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DraftFoundDialog;
